/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>

(function() {
  var ns = nspace("ccc.indicatorSelection");

  ns.IndicatorSelectionModel = Backbone.Model.extend({
    defaults: {
      selectedCategories: { 0: true },
      /** number: selects the given indicator */
      selectedIndicators: "0"
    }
  });
})(jQuery);
